import app from "../_app";

const popups = [...document.querySelectorAll('.js-popup')];
popups.map(popup => {
    const popupKey = popup.dataset.key;
    const handle = popup.querySelector('.js-popup-handle');
    const popupInner = popup.querySelector('.js-popup-inner');

    let triggers = [...document.querySelectorAll(`.js-popup-trigger[data-key="${popupKey}"]`)];
    const closeAllTriggers = [...document.querySelectorAll(`.js-popup-trigger-close-all`)];

    let handleStartTouchPosition = null;
    let handleLastTouchPosition = null;
    let handleLastDirectionChangePosition = null;
    let isHandleTouchDirectionDown = false;
    let handleDragged = false;

    const reinitTriggersHandler = () => {
        triggers.map(trigger => trigger.removeEventListener('click', togglePopupHandler))
        triggers = [...document.querySelectorAll(`.js-popup-trigger[data-key="${popupKey}"]`)];
        triggers.map(trigger => trigger.addEventListener('click', togglePopupHandler));
    }

    const togglePopupHandler = () => {
        if (popup.hasAttribute('data-open')) {
            popup.removeAttribute('data-open');
            app.unlockBody();
        } else {
            app.lockBody();
            popup.setAttribute('data-open', '');
        }
    };

    const handleTouchStartHandler = e => {
        e.preventDefault();

        handleStartTouchPosition = handleLastTouchPosition = handleLastDirectionChangePosition = e.touches[0].clientY;
        handleDragged = false;

        document.addEventListener('touchmove', handleTouchMoveHandler);
        document.addEventListener('touchend', handleTouchEndHandler);
    };

    const handleTouchMoveHandler = e => {
        handleLastTouchPosition = e.changedTouches[0].clientY;
        handleDragged = true;

        const newPositionDifference = handleLastTouchPosition - handleLastDirectionChangePosition;

        if (newPositionDifference > 10) {
            isHandleTouchDirectionDown = true;
            handleLastDirectionChangePosition = handleLastTouchPosition;
        } else if (newPositionDifference < -10) {
            isHandleTouchDirectionDown = false;
            handleLastDirectionChangePosition = handleLastTouchPosition;
        }

        if (handleLastTouchPosition > handleStartTouchPosition) {
            popupInner.style.transform = `translateY(${handleLastTouchPosition - handleStartTouchPosition}px)`;
        } else {
            popupInner.style.removeProperty('transform');
        }
    };

    const handleTouchEndHandler = () => {
        if (isHandleTouchDirectionDown || !handleDragged) {
            togglePopupHandler();
        } else {
            popupInner.style.transform = 'translateY(0)';
        }

        setTimeout(() => {
            popupInner.style.removeProperty('transform');
        }, 700);

        document.removeEventListener('touchmove', handleTouchMoveHandler);
        document.removeEventListener('touchend', handleTouchEndHandler);
    };

    const closeAllPopups = () => {
        popups.map(p => {
            p.removeAttribute('data-open');
            app.unlockBody();
        });
    }

    if (handle) {
        handle.addEventListener('touchstart', handleTouchStartHandler);
    }

    triggers.map(trigger => trigger.addEventListener('click', togglePopupHandler));
    closeAllTriggers.map(closeAllTrigger => closeAllTrigger.addEventListener('click', closeAllPopups));

    window.addEventListener(`popup.toggle.${popupKey}`, togglePopupHandler);
    window.addEventListener('popup.reinit-triggers', reinitTriggersHandler);
});




